import React, { useState, useEffect } from 'react';
import { crmValidator } from 'helpers';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import { Field, reduxForm } from 'redux-form';
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";
import { connect } from 'react-redux';
import { surveyAction } from 'actions';
import * as FormValidator from './validate/FormValidator';



const QueryForm = ({ surveyList, onSubmit, fetchSurveyList, dispatch, reset }) => {
    const [query, setQuery] = useState({
        surveyId: '',
        startDate: '',
        endDate: ''
    });
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);

    useEffect(() => {
        fetchSurveyList();  // Call the action to fetch survey list
    }, [fetchSurveyList]);

    const handleChange = (value, name) => {
        console.log(`${name}: ${value}`); 
        setQuery(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChange2 = (e) => {

            const { name, value } = e.target;
            console.log(`${name}: ${value}`);  // Log to verify the state update
            setQuery({
                ...query,
                [name]: value
            });
            console.log("Enable Form");
            // If the 'surveyId' is selected (i.e., it's not empty), show additional fields
            if (name === 'surveyId' && value) {
                setShowAdditionalFields(true);  // Show additional fields
                console.log("Additional fields enabled");
            } else if (name === 'surveyId' && !value) {
                setShowAdditionalFields(false);  // Hide additional fields
                console.log("Additional fields disabled");
            }

    };

    const handleSubmit = (e) => {
        e.preventDefault();
   

        console.log("query.surveyId : ", query.surveyId);
        console.log("query.startDate : ", query.startDate);
        console.log("query.endDate : ", query.endDate);

        

        let reqParams = "";

        // if (query.surveyId) {
        //     reqParams += 'surveyId=' + encodeURIComponent(query.surveyId);
        // }

        //Only add surveyId if it's not empty or undefined
        //const errors = {};
        if (query.surveyId && query.surveyId !== '') {
            reqParams += 'surveyId=' + encodeURIComponent(query.surveyId);
        } else {
            //errors.surveyId = 'Survey Name is required';
            //return errors;
            //console.warn("surveyId is required but is missing. Not dispatching action.");
            return; // Stop execution if surveyId is missing
        }

         
        
        if (query.startDate) {
            reqParams += (reqParams ? '&' : '') + 'startDate=' + encodeURIComponent(query.startDate);
        }
        
        if (query.endDate) {
            reqParams += (reqParams ? '&' : '') + 'endDate=' + encodeURIComponent(query.endDate);
        }

        if (query.firstName) {
            reqParams += (reqParams ? '&' : '') + 'firstName=' + encodeURIComponent(query.firstName);
        }

        if (query.lastName) {
            reqParams += (reqParams ? '&' : '') + 'lastName=' + encodeURIComponent(query.lastName);
        }

        if (query.memberId) {
            reqParams += (reqParams ? '&' : '') + 'memberId=' + encodeURIComponent(query.memberId);
        }

        dispatch(surveyAction.getCompleteSurveyLists(reqParams));
    };

    const handleClear = () => {
        //reset(); // Reset the form
        setQuery({
            surveyId: '',
            startDate: '',
            endDate: '',
            firstName: '',
            lastName: '',
            memberId: ''
        });
        setShowAdditionalFields(false); 
        reset(); // Reset the form
        
    };

     const surveyOptions = Array.isArray(surveyList.surveys) ? 
     surveyList.surveys.map(survey => ({ value: survey._id, label: survey.name })) : [];

    // const surveyOptions = [
    //     { value: '', label: 'Select Survey' },  // Default unselected option
    //     ...Array.isArray(surveyList.surveys) ? 
    //         surveyList.surveys.map(survey => ({ value: survey._id, label: survey.name })) : []
    // ];
    

    return (
        <form onSubmit={handleSubmit} name="queryForm">
            <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                    <Field
                        id='survey-name-select'
                        name="surveyId"
                        component={CustomSelect}
                        type="text"
                        labelText="Survey Name *"
                        formControlProps={{ fullWidth: true }}
                        optionsList={surveyOptions}
                        //onChange={(value) => handleChange2(value, 'surveyId')}
                         onChange={handleChange2}
                        // onChange={(e) => {
                        //     handleChange2(e.target.value, 'surveyId');  // Call handleChange2 with value and name
                        //     enableForm();  // Enable the rest of the form
                        // }}
                    />
                </GridItem>
            </GridContainer>

            {showAdditionalFields && (
            <>

            <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                    <Field
                        id='start-date-select'
                        name="startDate"
                        component={CustomDatePicker}
                        type="text"
                        labelText="Start Date "
                        dateFormat="DD-MMM-YY"
                        timeFormat="HH:mm"
                        formControlProps={{ fullWidth: true }}
                        onChange={(value) => handleChange(value, 'startDate')}
                    />
                </GridItem>

                <GridItem xs={12} sm={4} md={4}>
                    <Field
                        id='end-date-select'
                        name="endDate"
                        component={CustomDatePicker}
                        type="text"
                        labelText="End Date"
                        dateFormat="DD-MMM-YY"
                        timeFormat="HH:mm"
                        formControlProps={{ fullWidth: true }}
                        onChange={(value) => handleChange(value, 'endDate')}
                    />
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                    <Field
                        id='firstName-input'
                        name="firstName"
                        component={CustomInput}
                        type="text"
                        labelText="Member Name:"
                        formControlProps={{
                            fullWidth: true
                        }}
                        //disabled={readOnly}
                        //onChange={(value) => handleChange(value, 'firstName')}
                        onChange={handleChange2}
                    />
                    
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                    <Field
                        id='lastName-input'
                        name="lastName"
                        component={CustomInput}
                        type="text"
                        labelText="Surname:"
                        formControlProps={{
                            fullWidth: true
                        }}
                        //disabled={readOnly}
                        //onChange={(value) => handleChange(value, 'lastName')}
                        onChange={handleChange2}
                    />
                    
                </GridItem>

                <GridItem xs={12} sm={4} md={4}>
                    <Field
                        id='memberId-input'
                        name="memberId"
                        component={CustomInput}
                        type="text"
                        labelText="Member ID:"
                        formControlProps={{
                            fullWidth: true
                        }}
                        //disabled={readOnly}
                        //onChange={(value) => handleChange(value, 'memberId')}
                        onChange={handleChange2}
                    />
                    
                </GridItem>

                
            </GridContainer>

            <Button
                id='submit-btn'
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginTop: '20px' }}
            >
                Search
            </Button>

            <Button
                id='clear-btn'
                type="button"
                variant="outlined"
                color="secondary"
                style={{ marginLeft: '10px', marginTop: '20px' }}
                onClick={handleClear}
            >
                Clear
            </Button>

            </>
            )}

        </form>
    );
};

const mapStateToProps = (state) => ({
    surveyList: state.survey.surveyList,
});

const mapDispatchToProps = {
    fetchSurveyList: surveyAction.fetchSurveyList
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'queryForm',
    //validate,
    // onSubmit: handleSubmit, 
})(QueryForm));
